// Turn an axios error into a message worth showing a user (and worth
// screenshotting to us). `err.response?.data?.message` covers the normal
// case — the server always answers with { message }. When that's missing,
// distinguish WHY instead of collapsing everything to a bare "Error":
//   - a response came back but had no JSON message (gateway/HTML error page)
//   - no response came back at all (network drop, timeout, CORS)
export function extractErrorMessage(err: any, fallback = 'Something went wrong'): string {
  const serverMessage = err?.response?.data?.message;
  if (serverMessage) return serverMessage;
  if (err?.response) return `${fallback} (server returned ${err.response.status} with no details — try again)`;
  if (err?.request) return `${fallback} — no response from server. Check your connection and try again.`;
  return fallback;
}
